import React from "react";
import ReactDOM from "react-dom";
import App from "./Components/root/App";
import { BrowserRouter } from "react-router-dom";

// STYLE
import "bootstrap/dist/css/bootstrap.min.css";

// REDUX
import { Provider } from "react-redux";
import { store } from "./Redux/store";

const noop = () => {};
console.warn = noop;
console.error = noop;


if(process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
